'use client';

import { useState } from 'react';
import { useReducedMotion } from './useReducedMotion';

export function useReducedMotionLocal() {
  const reducedMotion = useReducedMotion(state => state.reducedMotion);
  const [override, setOverride] = useState<boolean>(false);
  const setReducedMotionLocal = (reducedMotionLocal: boolean) => {
    setOverride(!reducedMotionLocal);
  };
  const toggleReducedMotionLocal = () => {
    setOverride(!override);
  };
  const reducedMotionLocal = reducedMotion && !override;
  return {
    reducedMotionLocal,
    setReducedMotionLocal,
    toggleReducedMotionLocal,
  };
}
